import React from "react";
import { ClipboardCheckIcon, CalculatorIcon, MessageCircleIcon } from "lucide-react";
import { images } from "../data/offer";
const highlights = [{
  icon: ClipboardCheckIcon,
  title: "Checklists listos",
  text: "Para organizar cada servicio y revisar resultados."
}, {
  icon: CalculatorIcon,
  title: "Fórmulas de precios",
  text: "Para calcular tarifas y ganancias con tus costos."
}, {
  icon: MessageCircleIcon,
  title: "Mensajes modelo",
  text: "Para escribir a clientes por WhatsApp y redes."
}];
export function Preview() {
  return <section className="bg-ink py-20 text-cream md:py-28" aria-labelledby="preview-title" data-id="element-184" data-mp="1ny1tlcul8kkb">
      <div className="mx-auto max-w-6xl px-5 md:px-8" data-id="element-185" data-mp="1jy9gcmu91q8m">
        <div className="mx-auto max-w-2xl text-center" data-id="element-186" data-mp="1ez6ne0rjnah0">
          <h2 id="preview-title" className="font-display text-3xl font-semibold leading-tight md:text-[2.75rem]" data-id="element-187" data-mp="1ewk4x6347ak0">
            Mirá lo que vas a tener en tus manos
          </h2>
          <p className="mt-4 text-lg leading-relaxed text-cream/80" data-id="element-188" data-mp="151sagb4tx3tg">
            Contenido práctico, pensado para consultar mientras trabajás: en el celular, la compu o impreso.
          </p>
        </div>

        <div className="mt-12 grid gap-6 lg:grid-cols-[1.35fr_1fr] lg:items-start" data-id="element-189" data-mp="37xxodwoyt57d">
          <div data-id="element-190" data-mp="2t8t5edaciwy7">
            <img src={images.insidePages} width={1344} height={768} loading="lazy" decoding="async" alt="Páginas interiores de la guía con un checklist de limpieza y una tabla de precios" className="aspect-[16/10] w-full rounded-[1.75rem] object-cover" data-id="element-191" data-mp="2t9bbe1mt8pjb" />
            <ul className="mt-8 grid gap-6 sm:grid-cols-3" data-id="element-192" data-mp="3byrcaq2eqk09">
              {highlights.map(({
              icon: Icon,
              title,
              text
            }) => <li key={title} className="flex gap-3 sm:flex-col" data-id="element-193" data-mp="3gvht5fm1djmq">
                  <Icon className="mt-0.5 h-6 w-6 shrink-0 text-sun" aria-hidden="true" data-id="element-194" data-mp="20ijh59pb2aym" />
                  <div data-id="element-195" data-mp="25ifdqnvob045">
                    <h3 className="font-bold" data-id="element-196" data-mp="25ip3qbgpx79u">{title}</h3>
                    <p className="mt-1 text-sm leading-relaxed text-cream/75" data-id="element-197" data-mp="byx7zah0xxo7">{text}</p>
                  </div>
                </li>)}
            </ul>
          </div>

          <figure className="mx-auto w-full max-w-sm lg:max-w-none" data-id="element-198" data-mp="72g7dgsn1qu8">
            <img src={images.bundle} width={1024} height={1536} loading="lazy" decoding="async" alt="Vista general del ebook De cero a tu empresa de limpieza junto a los 8 bonos" className="w-full rounded-[1.75rem]" data-id="element-199" data-mp="27ss88jiy8sb" />
            <figcaption className="mt-3 text-center text-sm text-cream/70" data-id="element-200" data-mp="3khcuvlmifilw">
              Vista general del ebook y los 8 bonos
            </figcaption>
          </figure>
        </div>
      </div>
    </section>;
}